import BigNumber from 'bignumber.js';

export const WEI = new BigNumber(10 ** 18);
export const GWEI = new BigNumber(10 ** 9);
export const WEI_IN_GWEI = WEI.dividedBy(GWEI);
export const ZERO = new BigNumber(0);

export const SECOND = 1_000;
export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;
export const DAY = 24 * HOUR;
export const WEEK = 7 * DAY;
export const MONTH = 30 * DAY;
export const YEAR = 365 * DAY;

export const Kb = 1_000;
export const Mb = 1_000 * Kb;

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';

export const SITE_MAP_OLD_UI = {
  '/': 'https://dep.ftnscan.com',
  '/txs': 'https://dep.ftnscan.com/txs',
  '/blocks': 'https://dep.ftnscan.com/blocks',
  '/accounts': 'https://dep.ftnscan.com/accounts',
  '/tokens': 'https://dep.ftnscan.com/tokens',
  '/withdrawals': 'https://dep.ftnscan.com/withdrawals',
  '/verified-contracts': 'https://dep.ftnscan.com/verified-contracts',
  '/l2-deposits': 'https://dep.ftnscan.com/l2-deposits',
  '/l2-output-roots': 'https://dep.ftnscan.com/l2-output-roots',
  '/l2-txn-batches': 'https://dep.ftnscan.com/l2-txn-batches',
  '/l2-withdrawals': 'https://dep.ftnscan.com/l2-withdrawals',
  '/address/[hash]': 'https://dep.ftnscan.com/address/[hash]',
  '/address/[hash]/contract-verification': 'https://dep.ftnscan.com/address/[hash]/contract_verifications/new',
  '/tx/[hash]': 'https://dep.ftnscan.com/tx/[hash]',
  '/block/[height_or_hash]': 'https://dep.ftnscan.com/block/[height_or_hash]',
  '/token/[hash]': 'https://dep.ftnscan.com/token/[hash]',
  '/token/[hash]/instance/[id]': 'https://dep.ftnscan.com/token/[hash]/instance/[id]',
};
